import { render, staticRenderFns } from "./emailRegister.vue?vue&type=template&id=71aea640&scoped=true"
import script from "./emailRegister.vue?vue&type=script&lang=js"
export * from "./emailRegister.vue?vue&type=script&lang=js"
import style0 from "./emailRegister.vue?vue&type=style&index=0&id=71aea640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aea640",
  null
  
)

export default component.exports